/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'company-hub.search-extension.custom-search-config-panel.corner-style-label': 'Corners',
  'company-hub.search-extension.custom-search-config-panel.default-placeholder-text':
    'Search for verified announcements, resources, and policies',
  'company-hub.search-extension.custom-search-config-panel.filters-title': 'Filters',
  'company-hub.search-extension.custom-search-config-panel.placeholder-text-label': 'Placeholder text',
  'company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label':
    'Customize the prompt your readers will see',
  'company-hub.search-extension.custom-search-config-panel.preamble': 'Add a filtered search bar',
  'company-hub.search-extension.custom-search-config-panel.round-corner-style-label': 'Round',
  'company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label': 'Square',
  'company-hub.search-extension.custom-search-config-panel.styles-fill-color-label': 'Fill color',
  'company-hub.search-extension.custom-search-config-panel.styles-text-color-label': 'Text color',
  'company-hub.search-extension.custom-search-config-panel.styles-title': 'Styles',
  'company-hub.search-extension.custom-search-config-panel.title': 'Custom search',
  'company-hub.search-extension.manifest.default-placeholder-text':
    'Search for verified announcements, resources, and policies',
  'company-hub.search-extension.manifest.macro-description': 'Add a filtered search bar',
  'company-hub.search-extension.manifest.macro-title': 'Custom search',
  'company-hub.search-extension.more-button': 'View more results',
};
